import { Grid, Button, CircularProgress } from '@mui/material'
import { ReactNode, useState } from 'react'
import { translate } from '../../../i18n'
// import { formatYmdWeek, formatYm } from '../../../utils/dateUtil'
import { Card } from '../common/card'
import { LabelItemBase, RightItem, ValueItemBase } from '../common/gridItems'
// import { OperationId } from '../../../containers/common/constant/operationLog'
import {
  executeGetDownloadPdfUrl,
} from '../../../dataAccess/webApi/dao/acceptNoticeDao'
import { downloadFile } from '../../../utils/reactUtil'

interface BatchResult {
  batchId: string
  reservationType: number
  reservationDate: string
  facilityId: string
  userId: string
  childId: string
  usageDates: string
  facilityName: string
  childName: string
}

const LabelItem = (props: { children?: ReactNode }) => <LabelItemBase xs={4}>{props.children}</LabelItemBase>
const ValueItem = (props: { children: ReactNode }) => <ValueItemBase xs={8}>{props.children}</ValueItemBase>

export const AcceptNoticeCard = (props: BatchResult) => {
  const [isDownLoading, setIsDownLoading] = useState(false)

  console.log('props:', props)

  const {
    reservationDate,
    facilityName,
    childName,
    reservationType,
    usageDates,
    batchId,
    facilityId,
    childId,
  } = props

  const joinedUsageDates = usageDates
    .split(',')
    .map(date => parseInt(date.split('-')[2]))
    .join(' / ');

  const desiredUsageMonth = usageDates
    .split(',')[0]
    .split('-')
    .slice(0, 2)
    .join('/'); 

  const handleClick = async () => {
    setIsDownLoading(true)

    const input = {
      batchId,
      facilityId,
      childId,
      reservationDate,
    }

    const resPdfUrl = await executeGetDownloadPdfUrl(input)
    downloadFile(resPdfUrl.result.url)

    setIsDownLoading(false)
  }

  return (
    <Card>
      <Grid container>
        {/* 申込日 */}
        <LabelItem>{translate('reservationStatusList.label.acceptNoticeDatetime')}</LabelItem>
        <ValueItem>{reservationDate.replace(/-/g, '/')}</ValueItem>

        {/* 施設名 */}
        <LabelItem>{translate('reservationStatusList.label.facilityName')}</LabelItem>
        <ValueItem>{facilityName}</ValueItem>

        {/* お子さま氏名 */}
        <LabelItem>{translate('reservationStatusList.label.childName')}</LabelItem>
        <ValueItem>{childName}</ValueItem>

        {/* 申込方法 */}
        <LabelItem>{translate('reservationStatusList.label.reservationMethod')}</LabelItem>
        <ValueItem>{reservationType === 1 ? '通常申込' : '抽選予約'}</ValueItem>

        {/* 利用希望月 */}
        <LabelItem>{translate('reservationStatusList.label.desiredUsageMonth')}</LabelItem>
        <ValueItem>{desiredUsageMonth}</ValueItem>

        {/* 利用希望日 */}
        <LabelItem>{translate('reservationStatusList.label.desiredUsageDay')}</LabelItem>
        <ValueItem>{joinedUsageDates}</ValueItem>

        <RightItem item xs={12}>
          {isDownLoading && <><CircularProgress size="2rem" style={{ marginRight: '10px' }} />ダウンロード中...</>}
          <Button size="small" variant="outlined" style={{ marginLeft: '10px' }} onClick={handleClick} disabled={isDownLoading}>
            承諾通知書ダウンロード
          </Button>
        </RightItem>
      </Grid>
    </Card>
  )
}
